export default {
  supplierbanner: {
    subtitle: "FOR SUPPLIERS",

    title1: "Grow Your Sales.",
    title2: "Manage Orders Easily.",

    desc:
      "MAHAL helps suppliers connect with verified restaurants, manage orders efficiently, and scale their business through a powerful B2B marketplace.",

    cta: "Join as Supplier",
  },
};